import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const fetchUserDetails = (login) => {
  return axios({
    url: '/user/list/' + login,
    method: 'get'
  });
};

const useGetUser = (login) => {
  return useQuery(['user', login], () => fetchUserDetails(login), {
    enabled: !!login
  });
};

export default useGetUser;
